function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { coreAxiosInstance } from '../api/config';
import { useMutation as useMutationRQ } from 'react-query';
import { usePostBase } from '@unite-us/json-api-resources';
import { useAppCreateReferralContext } from '../context/AppCreateReferralProvider';
export var usePatch = function usePatch(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = usePostGeneric(url, options);
  var doExecute = callback.doExecute;
  callback.patchFn = function (data) {
    var overrideOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return doExecute(data, _objectSpread(_objectSpread({}, overrideOptions), {}, {
      method: 'PATCH'
    }));
  };
  callback.doExecute = null;
  return callback;
};
var usePostGeneric = function usePostGeneric(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = usePostBase({
    useMutation: useMutationRQ,
    mutationConfig: options.mutationConfig
  });
  var mutateAsync = callback.mutateAsync;
  // avoiding accidental calls to mutateAsync and mutate from usePostBase
  // by removing them from the callback object
  callback.mutate = null;
  callback.mutateAsync = null;
  callback.doExecute = function (data) {
    var overrideOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var api = coreAxiosInstance;
    var newData = {
      url: url,
      data: data,
      params: _objectSpread({
        method: 'POST',
        api: api
      }, overrideOptions)
    };
    return mutateAsync(newData, overrideOptions.mutationConfig);
  };
  return callback;
};
export default function useUpdateResourceList(resourceListId) {
  // In order to use relationships in our updateResourceList, we can't use the standard
  // coreApi.createRecord, so we revert to using the json-api-resources
  var _useAppCreateReferral = useAppCreateReferralContext(),
    _useAppCreateReferral2 = _useAppCreateReferral.state,
    currentEmployee = _useAppCreateReferral2.currentEmployee,
    sourceApp = _useAppCreateReferral2.source,
    formSubmissionId = _useAppCreateReferral2.formSubmissionId;
  var _usePatch = usePatch("resource_lists/".concat(resourceListId)),
    patchFn = _usePatch.patchFn;
  var updateResourceList = function updateResourceList(_ref) {
    var programServicesPayload = _ref.programServicesPayload;
    return patchFn({
      data: {
        attributes: _objectSpread(_objectSpread({
          updated_via_type: "referral",
          originating_app: sourceApp
        }, formSubmissionId && {
          created_via_id: formSubmissionId
        }), {}, {
          updated_by: currentEmployee === null || currentEmployee === void 0 ? void 0 : currentEmployee.id
        }),
        relationships: {
          employee: {
            data: {
              type: 'employee',
              id: currentEmployee === null || currentEmployee === void 0 ? void 0 : currentEmployee.id
            }
          },
          resource_list_program_services: {
            data: programServicesPayload
          }
        }
      }
    });
  };
  return updateResourceList;
}
//# sourceMappingURL=useUpdateResourceList.js.map